import { Blocks } from '@/components/PageEditor/types';
import { ActionItemType, AgendaType } from '@/modules/1on1s/views/1on1Editor/types';

import { StatusTypes } from '../PowerUps/enums';

export interface onSetLessonAssigneePayloadType {
  id: string;
}

export interface onUpdateLessonStatusPayloadType {
  newStatus: StatusTypes;
}

export interface onSetCommentThreadIdPayloadType {
  postId: string;
}

export interface onUpdateContentTextType {
  value: string;
  type: Blocks;
}

export interface onSetImportDialog {
  hide: boolean;
}

export interface onImportLessonPayloadType {
  title: string;
  uploadFileUserId: string;
  uploadFileUrl: string;
}

export interface onSetImportLessonAttrsPayloadType {
  uploadFileUserId?: string | null;
  uploadFileUrl?: string | null;
  uploadFileJobId?: string | null;
}

export enum EditorBuilderActions {
  UpdateContentText = 'UPDATE_LESSON_DESCRIPTION_OR_NOTES',
  SetLessonAssignee = 'SET_LESSON_ASSIGNEE',
  UpdateLessonStatus = 'UPDATE_LESSON_STATUS',
  SetCommentThreadId = 'SET_COMMENT_THREAD_ID',
  SetImportLessonAttrs = 'IMPORT_LESSON_ATTRS',
  SetImportDialog = 'SET_IMPORT_DIALOG',
  ImportLesson = 'IMPORTED_LESSON_ADD',
}

export interface ContentType {
  type: string;
  text?: string;
  attrs?: {
    id: string;
    duration?: number;
    updatedAt?: string;
    customDuration?: number;
    refId?: string;
    src?: string;
    yOffsetPercent?: number;
    commentThreadId?: string | null;
    status?: string;
    userId?: string | null;
    questionIds?: string[];
    uploadFileUserId?: string | null;
    uploadFileUrl?: string | null;
    uploadFileJobId?: string | null;
    isOptional?: boolean | null;
    agendas?: AgendaType[] | null;
    actionItems?: ActionItemType[] | null;
    actionItemIds?: string[] | null;
    noteContent?: string;
    isPrivate?: boolean;
    blockPosition?: string;
    title?: string;
    description?: string;
    thumbnail?: string;
    href?: string;
    embedUrl?: string | null;
    srcDoc?: string | null;
    redirectLink?: RedirectLinkAttr;
  };
  content?: ContentType[];
}

export interface RedirectLinkAttr {
  url: string;
  heading: string;
  buttonTitle: string;
}

export type onAction = (
  action: EditorBuilderActions,
  payload:
    | onSetLessonAssigneePayloadType
    | onUpdateLessonStatusPayloadType
    | onSetCommentThreadIdPayloadType
    | onUpdateContentTextType
    | onSetImportDialog
    | onImportLessonPayloadType
    | onSetImportLessonAttrsPayloadType,
) => void;
